import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl,Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import { ToastService } from 'src/app/core/services/misc/toast.service';

@Component({
  selector: 'app-social-history',
  templateUrl: './social-history.component.html',
  styleUrls: ['./social-history.component.scss']
})
export class SocialHistoryComponent implements OnInit {

  surgical_history_form = new FormGroup({
    name: new FormControl('', Validators.compose([ Validators.required,])),
    value: new FormControl(''),
    duration: new FormControl(''),
    remarks: new FormControl(''),
  });

  constructor(
    private matDialogRef: MatDialogRef<any>,
    private toast: ToastService,
    ) {}

  ngOnInit(): void {
  }

  save() {
    if(this.surgical_history_form.value.name){
      const object = this.surgical_history_form.value;
      object.is_default = false
      object.selected = true
      this.matDialogRef.close(object);
    }else{
      this.toast.showError('Please Enter Name');
    }

  }
}
